/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { useTranslations } from 'next-intl'

import { Breadcrumbs } from '@/components/e-commerce/Breadcrumbs'

/**
 * Custom 404 page for a blog category not found.
 *
 * A client component out of necessity, not preference: not-found boundaries receive no params, so
 * a server render here has no locale to work with — the previous server version's bare
 * `getTranslations`/`fetchBlogCategories` fell back to request headers, which forced the whole
 * statically-rendered category route dynamic. Translations come from the layout's
 * NextIntlClientProvider instead, and the category-filter list is gone because its fetch is
 * server-only and locale-implicit for the same reason.
 */
const BlogCategoryNotFound = () => {
  const t = useTranslations('BlogCategoryNotFound')

  return (
    <div className={'flex flex-col gap-4 mx-auto max-w-8xl w-full px-5 md:px-10 py-5'}>
      <Breadcrumbs items={[{ label: t('blog'), path: '/blog', current: true }]} />
      <div className={'flex flex-col justify-center text-center h-72'}>
        <h1 className={'mt-4 text-balance text-2xl font-semibold tracking-tight text-gray-900 sm:text-5xl'}>
          {t('categoryNotFound')}
        </h1>
        <p className={'mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8'}>
          {t('categoryNotFoundDescription')}
        </p>
      </div>
    </div>
  )
}

export default BlogCategoryNotFound
